import { affixToWorldUp } from "../utils/three-utils";
import { findAncestorWithComponent } from "../utils/scene-graph";
import { AGENT_EVENTS } from "../utils/agent-utils";
import { CAMERA_MODE_INSPECT } from "../systems/camera-system";

AFRAME.registerComponent("ai-proximity-audio", {
  schema: {
    distance: { default: 1 }
  },
  init() {
    // Get distance from camera to object
    this.enabled = false;
    this.distance = 0;
    this.camera = document.querySelector("#viewing-camera").object3DMap.camera;
    this.helperMat4 = new THREE.Matrix4();
    this.v1 = new THREE.Vector3();
    this.m1 = new THREE.Matrix4();
    this.up = new THREE.Vector3();
    this.backward = new THREE.Vector3();
    this.forward = new THREE.Vector3();
    this.camToObject = new THREE.Vector3();
    this.position = new THREE.Vector3();
    this.enableOnProximity = this.enableOnProximity.bind(this);
    this.lastTick = 0;
    // this.npcEl = findAncestorWithComponent(this.el, "npc-avatar");
    this.npcEl = findAncestorWithComponent(this.el, "ai-agent");
    this.initPosition = new THREE.Vector3();
    this.initPosition.copy(this.el.object3D.position);
    this.distanceAux = new THREE.Vector3();
    this.camToObjectAux = new THREE.Vector3();
    this.cameraSystem = window.APP.scene.systems["hubs-systems"].cameraSystem;
  },
  tick(now) {
    // Throttle to 5fps
    if (now - this.lastTick < 200) return;
    this.lastTick = now;

    const scene = this.el.sceneEl;
    if (!scene.is("entered")) return;

    this.enableOnProximity();
  },
  enableOnProximity() {
  const position = new THREE.Vector3();
  this.el.object3D.getWorldPosition(position);
  this.distance = this.camera.position.distanceTo(position);

  this.el.object3D.updateMatrixWorld();
  this.camera.updateMatrixWorld();

  affixToWorldUp(this.m1.copy(this.el.object3D.matrixWorld), this.m1).extractBasis(this.v1, this.up, this.backward);

  this.camToObject.subVectors(position, this.v1.setFromMatrixPosition(this.camera.matrixWorld));

  const initWorldPosition = new THREE.Vector3();
  this.el.object3D.getWorldPosition(initWorldPosition);
  this.camToObjectAux.subVectors(initWorldPosition, this.v1.setFromMatrixPosition(this.camera.matrixWorld));

  this.distanceAux = this.camToObjectAux.length();
  this.distance = this.camToObject.length();

  const isInspecting = this.cameraSystem.mode === CAMERA_MODE_INSPECT;

    const distanceEval = this.distanceAux;
    const npcComponent = this.npcEl?.components['npc-avatar'] || this.npcEl?.components['ai-agent'];
    if (distanceEval < this.data.distance && !this.enabled && this.el.object3D.visible && npcComponent && npcComponent && !isInspecting) {
      this.enabled = true;

      // if(aiAgents.status != "talking" && aiAgents.status != "listening" && aiAgents.status != "thinking") {
        // const voiceStrategy = npcComponent.data.voiceSpeechStrategy;
        // if(voiceStrategy != "Silent") {
        //   aiAgents.status = "listening";
        // }
        window.dispatchEvent(new CustomEvent(AGENT_EVENTS.AI_ON_ENTER_PROXIMITY, { detail: npcComponent?.id}));
      // }
      setTimeout(() => {
        npcComponent?.onProximityEnter();
      }, 200)

    } 
    else if (distanceEval > this.data.distance && this.enabled && !isInspecting) {
      if (npcComponent?.data.leaveColliderText) {
        window.dispatchEvent(new CustomEvent(AGENT_EVENTS.AI_ON_ENTER_PROXIMITY, { detail: npcComponent?.id}));
      }
      this.enabled = false;
      npcComponent?.onProximityLeave();
    }
  }
});
